<script>
    import { onMount } from "svelte";
    import OpenLayers from '../components/maps/openlayers.svelte'
    import {copyCanvas, annotationFromExtent} from '../lib/image-from-canvas';
    import {loadSettings} from '../lib/local-storage';
    import OutputLine from '../project/output-line.svelte';
    import Dialog, { Title, Content, Actions } from '@smui/dialog';
    import Button, { Label, Icon } from '@smui/button';
    import createZip from '../lib/download';

    import Card from '@smui/card';

    let renderResultComplete = () => {}
    let resultTemp = {
        center: null,
        zoom: null,
    }
    let settings = {};
    let realMapPreview;
    let realImageList = [];
    let openDetail = false;
    let detail;

    const updateSettings = () => {
        settings = {...loadSettings()}
    }
    onMount(() => {
        updateSettings();
        generateImages();
    });
    const isRendered = async(annotation, mapExtent, fileNameCount, resolve, reject, zoom) => {

        let canvas = await copyCanvas(document.querySelector('#ge-real-map-preview canvas'));

        resolve({
            fileName: `image-zoom${zoom}-${fileNameCount}`,
            canvas: canvas,
            dataUrl: canvas.toDataURL("image/jpeg", 0.95),
            annotation
        });
    }
    const generateImage = async(mapExtent, fileNameCount, zoom) => {
        
        return new Promise((resolve, reject) => {
            resultTemp.center = mapExtent.center;
            resultTemp.zoom = zoom;
            renderResultComplete = async (rendered) => {
                if(!rendered) {
                    reject();
                    return;
                }else{
                    
                    const annotation = annotationFromExtent(rendered, settings.foreground.extents, realMapPreview, settings.outputDimension);
                    isRendered(annotation, mapExtent, fileNameCount, resolve, reject, zoom)
                }
            }
        })
    }
    const generateImages = async() => {
        updateSettings();
        
        realImageList = [];
        let fileNameCount = settings.downloadCount;

        for(let zoomIndex = 0; zoomIndex <= settings.output.maxZoom - settings.output.minZoom; zoomIndex++){
            for (let index = 0; index < settings.background.extents.length; index++) {
                const resExtents = await generateImage(settings.background.extents[index], fileNameCount++, settings.output.minZoom + zoomIndex);
                realImageList = [...realImageList, resExtents];
            }
        }
        
    }
    const _openDetailBtn = (result) => {
        openDetail = true;
        detail = result;
    }
    const _download = (detail) => {
        createZip(detail);
    }
</script>

<div class="ge-row">
    <div class="mdc-typography--headline6 ge-margin">Preview</div>
        <Button on:click={generateImages}>
            <Label>Refresh</Label>
            <Icon class="material-icons">refresh</Icon>
        </Button>
</div>
{#if settings && settings.background && settings.background.extents.length >0}
    <div id="ge-real-map-preview" class="ge-hidden-preview">
        <svelte:component
            bind:this={realMapPreview}
            this={OpenLayers}
            rendercomplete={renderResultComplete}
            interactions={false}
            center={resultTemp.center}
            zoom={resultTemp.zoom}
            width={settings.outputDimension[0] + 'px'}
            height={settings.outputDimension[1] + 'px'}>
        </svelte:component>
    </div>
    <div class="ge-row-break">
        {#each realImageList as result}
            <div class="ge-a ge-margin" on:click={() => _openDetailBtn(result)}>
                <OutputLine settings={settings} result={result} mini={true} />
            </div>
        {/each}
    </div>
{:else}
    <div class="card-container">
        <Card padded variant="outlined" class="ge-margin">
            
            <div class="ge-margin"><small>Draw at least</small></div>
            <br/> 
            <b>1 BACKGROUND EXTENT</b>
            <br/> 
            <Icon class="material-icons">select_all</Icon>
            <br/>
            <div class="ge-margin"><small>and</small></div>
            <br/>
            <b>1 OBJECT EXTENT</b>
            <br/> 
            <Icon class="material-icons">nature</Icon>
        </Card>
    </div>
{/if}

{#if detail}
    <Dialog
        bind:open={openDetail}
        aria-labelledby="simple-title"
        aria-describedby="simple-content"
        surface$style="width: 850px; max-width: calc(100vw - 32px);"
        >
        <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
        <Content id="simple-content"><OutputLine settings={settings} result={detail} mini={false} responsiveRow={true} /></Content>
        <Actions>
            <Button on:click={_download([detail])}>
                <Label>Download</Label>
            </Button>
        </Actions>
    </Dialog>
{/if}
<div class="ge-row">
    <div class="ge-grow"></div>
    <div class="ge-margin">
        <Button on:click={_download(realImageList)} variant="raised">
            <Label>Download all</Label>
        </Button>
    </div>
</div>
<hr/>